export function hoverImage() {
  const block = document.getElementById('js-hoverImage');
  if (!block) return;
  const buttons = document.querySelectorAll('.js-hoverImageButton');
  buttons?.forEach((button) => {
    const target = document.getElementById('js-hoverImageTarget');
    if (!target) return;

    button.addEventListener('mouseover', () => {
      target.classList.add('_scaleImage');
    });

    button.addEventListener('mouseleave', () => {
      target.classList.remove('_scaleImage');
    });
  });
}
